
export default {

    "e-mail" : "e-mail",
    "password" : "password",
    "wrong_email_password" : "e-mail o password errati",
    "login" : "Accedi"

};